import(/* webpackMode: "eager" */ "/home/runner/work/yegnaweb/yegnaweb/src/components/PageLoader.tsx")